The identifier for the `Event` that generated the attempts.
